export function productList(){
	$('.product-2-section .product-item').on('click', function(){
		const $this = $(this);
		$this.toggleClass('active').siblings().toggleClass('de-active');
	})
};
